(() => {
  const truncateTextByAttribute = () => {
    const elements = document.querySelectorAll("[data-truncate]");

    elements.forEach((element) => {
      const maxLength = parseInt(element.getAttribute("data-truncate"), 10);
      const readMoreUrl = element.getAttribute("data-url");

      if (!Number.isNaN(maxLength)) {
        const pTag = element.querySelector("p");
        const target = pTag || element;
        const currentText = target.innerText;

        if (currentText.length > maxLength) {
          const truncated = `${currentText.substr(0, maxLength)}...`;
          target.innerText = truncated;

          if (readMoreUrl) {
            const readMoreLink = document.createElement("a");
            readMoreLink.href = readMoreUrl;
            readMoreLink.classList.add("advantage-article__read-more");
            readMoreLink.textContent = "mehr lesen";
            element.insertAdjacentElement("afterend", readMoreLink);
          }
        }
      }
    });
  };

  truncateTextByAttribute();
})();
